const ChairishContext = window.chairisher.context;

/**
 * @returns {string} Url to hit to get more reviews from the server.
 */
export function getReviewUrl() {
    return ChairishContext.REVIEW_API_URL || '';
}

/**
 * @returns {string} Chairish URL on partner's website.
 */
export function getReviewPartnerUrl() {
    return ChairishContext.REVIEWS_PARTNER_URL || '';
}

/**
 * @returns {number} Max number of times we can request more reviews from the server.
 */
export function getMaxOffset() {
    return ChairishContext.REVIEW_MAX_OFFSET || 2;
}

/**
 * @returns {Object.<string, number>} A mapping of page sizes to number of reviews per page.
 */
export function getPageSizes() {
    return ChairishContext.REVIEW_PAGE_SIZES || {};
}
